<template>
  <div>
    <van-overlay :show="sShow" z-index="5">
      <div class="overlay_con">
        <div class="code_con">
          <p class="m-tb-20 code_title">会员卡支付码</p>
          <div class="codeImage" v-show="QCode">
            <vue-qr :text="QCode" class="qr_code"></vue-qr>
            <!-- <img :src="electronicImage" alt=""> -->
          </div>
          <p class="m-t-20 m-b-60 c-lightgrey">结账时向收银员出示此码</p>
          <!-- <p class="c-orange code_tip">生成一次性支付码给好友</p> -->
          <van-icon
            name="close"
            class="close_btn_con"
            color="#fff"
            size="30"
            @click="onClose"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getMemberCardCode } from "@/api/member";

export default {
  name: "CardCodeCom",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    codeType: {
      type: [Number],
      default: 1,
    },
    memberAccountId: {
      type: [String, Number],
      default: "",
    },
  },

  watch: {
    show(val) {
      this.sShow = val;
      if (val) {
        this.handleGetCode();
      }
    },
  },
  data() {
    return {
      sShow: this.show,
      QCode: "",
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    handleGetCode() {
      clearTimeout(this.getCodeTimer);

      let requestParams = {
        VpnId: this.$store.state.vpnId,
        Type: this.codeType,
      };
      if (this.memberAccountId) {
        requestParams.MemberAccountId = this.memberAccountId;
      }
      getMemberCardCode(requestParams)
        .then((res) => {
          console.log(res);
          this.QCode = res.Id + "";
          this.getCodeTimer = setTimeout(
            this.handleGetCode,
            (res.ValidDuration ? res.ValidDuration : 60) * 1000
          );
        })
        .catch((err) => {});
    },
    onClose() {
      if (this.getCodeTimer) clearTimeout(this.getCodeTimer);
      this.$emit("update:show", false);
    },
  },
};
</script>
<style scoped lang="scss">
.overlay_con {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.code_con {
  border-radius: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  padding: 20px 0;
  font-size: 26px;
  width: 80vw;
  position: relative;

  .code_title {
    font-size: 30px;
  }
  .code_tip {
    text-decoration: underline;
  }
  .qr_code {
    width: 500px;
  }
  .close_btn_con {
    position: absolute;
    bottom: -90px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
